import { AppRegistry } from 'react-native';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { animationKeyframes } from './utils/animations';

// Inject global animation styles
const styleElement = document.createElement('style');
styleElement.innerHTML = animationKeyframes;
document.head.appendChild(styleElement);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

AppRegistry.registerComponent('App', () => App);

// Remove legacy service workers/API caches. API responses are authenticated and
// team-scoped, so a service worker must never reuse them after an admin changes
// a user's team or a team's shared-data setting.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .catch(() => {});

    if ('caches' in window) {
      caches.keys()
        .then((names) => Promise.all(
          names
            .filter((name) => name.startsWith('convpilot-'))
            .map((name) => caches.delete(name)),
        ))
        .catch(() => {});
    }
  });
}
